var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 13.02L18.98 13.94L9.92 23H9V22.08L18.06 13.02ZM21.66 7C21.41 7 21.15 7.1 20.96 7.29L19.13 9.12L22.88 12.87L24.71 11.04C25.1 10.65 25.1 10.02 24.71 9.63L22.37 7.29C22.17 7.09 21.92 7 21.66 7ZM18.06 10.19L7 21.25V25H10.75L21.81 13.94L18.06 10.19Z",
    fill: "#2E3135"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.53348a0a5c0f1d03f854106cbffb8525.svg";
export { ForwardRef as ReactComponent };